import { render, staticRenderFns } from "./ConsultasDetalheDocumentosFornecedor.vue?vue&type=template&id=437e4371"
import script from "./ConsultasDetalheDocumentosFornecedor.vue?vue&type=script&lang=js"
export * from "./ConsultasDetalheDocumentosFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports